import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { WarningSmallIcon } from './utils/IconFactory';
const PaymentCardPicker = (props) => {
    var _a, _b;
    const tr = (_a = props.t) !== null && _a !== void 0 ? _a : (v => v);
    const showInfo = (_b = props.showInfo) !== null && _b !== void 0 ? _b : true;
    return (_jsxs(Container, { className: `${props.className || ''} ui-payment-card-picker`, children: [showInfo && _jsxs(Info, { className: 'switcher_info', children: [_jsx(WarningSmallIcon, {}), props.t ? tr("chronos.app.selectTheTypeOfCardToPayment") : 'Выберите тип карты для оплаты'] }), _jsx(Switcher, { className: 'switcher_bg', children: props.items.map((item, idx) => {
                    return _jsx(Button, { className: 'switcher_button', onClick: () => props.onChange(item), active: item === props.value, children: props.t ? tr(item.title) : item.title }, `${idx}_btn`);
                }) })] }));
};
export default PaymentCardPicker;
const Container = styled.div `
  width: 100%;
  margin-bottom: 1rem;
`;
const Info = styled.div `
  width: 100%;
  color: #F59300;
  padding: 1rem 0;
  font-size: 0.875rem;

  display: flex;
  justify-content: start;
  align-items: center;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
  }
`;
const Switcher = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  background-color: var(--switcher-background);
  border-radius: 5px;
  padding: 0.25rem;
`;
const Button = styled.div `
  width: 100%;
  cursor: pointer;
  padding: 0.5rem 0;
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: var(--ui-font-weight-bold);

  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.active && css `
    background-color: var(--switcher-button-background);
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.12), 0px 3px 1px rgba(0, 0, 0, 0.04);
    border: 0.5px solid rgba(0, 0, 0, 0.04);
    border-radius: 4px;
  `}
`;
